import React from 'react';
import { useHistory } from 'react-router';
// import ReactGA from 'react-ga';
import Sponsors from '../Sponsors/Sponsors';
import About from '../About/About';
// import CountDown from '../../components/Countdown/CountDown';
import SpeakersContainer from '../Speakers/Speakers';
import Hosts from '../Hosts/Hosts';
import Patronage from '../Patronage/Patronage';
import './Home.scss';
import PrivacySection from '../PrivacySection/PrivacySection';

const year = 2022;

const Home = () => {
  const history = useHistory();
  // const onRegisterClick = () => {
  //   if (document.cookie.replace(/(?:(?:^|.*;\s*)ga_gdpr\s*=\s*([^;]*).*$)|^.*$/, '$1') === 'yes') {
  //     ReactGA.event({
  //       category: 'Button',
  //       action: 'Clicked Register Now button'
  //     });
  //   }
  // };

  return (
    <div id="home-section">
      <div className="container">
        <div className="home">
          <div />
          <div className="home-middle">
            <div className="home-middle-first-row" />
            <div className="home-middle-second-row">
              <div className="logo">
                <div>
                  <span className="bold-text">OPEN</span>
                  <span className="light-text">SLAVA</span>
                  <span className="bold-text">`22</span>
                </div>
              </div>
              <div className="logo-subtitle">
                <div>Uniting technology and sustainability</div>
              </div>
            </div>
            <div className="home-middle-third-row">
              <div className="logo-button">
                {/* <a
                  className="button"
                  href="https://cvent.me/522a7a?RefId=Registration"
                  id="cfs-button"
                  rel="noopener noreferrer"
                  target="_blank">
                  REGISTER NOW
                </a> */}
                {/* <button
                  className="button"
                  id="cfs-button"
                  onClick={() => history.push('/livestream')}
                  type="button">
                  Livestream
                </button>
                <button
                  className="button"
                  id="cfs-button"
                  onClick={() => history.push('/ff')}
                  type="button">
                  Feedback Form
                </button> */}
                <a
                  className="button"
                  href="https://photos.app.goo.gl/Uh64wfTrcnxbovaw7"
                  id="cfs-button"
                  rel="noopener noreferrer"
                  target="_blank">
                  PHOTOS
                </a>
                <button
                  className="button"
                  id="cfs-button"
                  onClick={() => history.push('/program')}
                  type="button">
                  RECORDINGS
                </button>
              </div>
            </div>
            <div className="home-middle-fourth-row">
              <div className="home-bottom-left">
                <span>ACCENTURE CONFERENCE ON</span>
                <span>EMERGING TECHNOLOGIES</span>
                <span>AND OPEN SOURCE</span>
              </div>
              <div className="home-bottom-right">
                <span>October 19-20, {year}</span>
                <span>FEI STU BRATISLAVA</span>
                <span>SLOVAKIA</span>
              </div>
            </div>
            {/* <div className="home-middle-third-row">
              <CountDown
                afterDateMessage=""
                givenDate={new Date(`Oct 19 ${year} 15:00:00`)}
                title=""
              />
            </div> */}
          </div>
        </div>
      </div>
      <></>
      <Patronage />
      <About />
      <Hosts />
      <SpeakersContainer />
      <Sponsors />
      <PrivacySection />
    </div>
  );
};

export default Home;
